import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NewProjectView } from '../../models/form/NewProjectView';
import { FormSearch } from '../../models/dashboard/FormStatus';
import { BaseDashboard } from '../../models/dashboard/BaseDashboard';
import { UtilityService } from '../utility.service';
import { NewProjectCreator } from '../../models/form/NewProjectCreator';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class NewProjectFormService {
	private readonly urlPath = 'new-project';
	constructor(private httpClient: HttpClient, private utilityService: UtilityService) {}

	createForm(clientId: string, form: NewProjectCreator): Observable<NewProjectView> {
		const formData: FormData = new FormData();
		for (let i = 0; i < form.attachments.length; i++) {
			const name = `attachment-${i + 1}`;
			formData.append(name, form.attachments[i].file);
			form.attachments[i].file = null;
			form.attachments[i].name = name;
		}

		formData.append('model', JSON.stringify(form));
		return this.httpClient
			.post<NewProjectView>(`${environment.apiUrl}forms/clients/${clientId}/new-project`, formData)
			.pipe();
	}

	updateForm(clientId: string, formId: string, request: any): Observable<any> {
		return this.httpClient
			.put<any>(`${environment.apiUrl}forms/clients/${clientId}/new-project/${formId}`, request)
			.pipe();
	}

	getFormsFor(clientId: string, userId: string, search: FormSearch): Observable<BaseDashboard<any>> {
		let url = `${
			environment.apiUrl
		}forms/clients/${clientId}/new-project/users/${userId}?${this.utilityService.objectToQueryString(search)}`;
		return this.httpClient.get<BaseDashboard<any>>(url).pipe();
	}

	getForm(clientId: string, id: string): Observable<NewProjectView> {
		return this.httpClient
			.get<NewProjectView>(`${environment.apiUrl}forms/clients/${clientId}/new-project/${id}`)
			.pipe();
	}

	rejectForm(
		clientId: string,
		formId: string,
		rejectionReason: { reason: string; workflowId: number }
	): Observable<NewProjectView> {
		return this.httpClient
			.post<NewProjectView>(
				`${environment.apiUrl}forms/clients/${clientId}/new-project/${formId}/decline`,
				rejectionReason
			)
			.pipe();
	}

	approveForm(clientId: string, formId: string, userId: string): Observable<NewProjectView> {
		return this.httpClient
			.post<NewProjectView>(`${environment.apiUrl}forms/clients/${clientId}/new-project/${formId}/approve`, { userId })
			.pipe();
	}

	saveProjectNumber(clientId: string, formId: string, projectNumber: any): Observable<NewProjectView> {
		return this.httpClient
			.post<NewProjectView>(`${environment.apiUrl}forms/clients/${clientId}/new-project/${formId}/project-number`, {
				projectNumber,
			})
			.pipe();
	}
	sendBack(clientId: string, formId: string): Observable<NewProjectView> {
		return this.httpClient
			.post<NewProjectView>(`${environment.apiUrl}forms/clients/${clientId}/new-project/${formId}/review`, {})
			.pipe();
	}
}
